module.exports = __webpack_public_path__ + "static/media/2.efa70d42.jpeg";